import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const apiUrl = process.env.REACT_APP_API_URL;

const ListRiskFlag = () => {
  const navigate = useNavigate();
  const [riskData, setRiskData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const fetchRiskFlagRecords = async (page) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${apiUrl}fetch-risk-flag-records?page=${page}&limit=15`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { data, pagination } = response.data;
      setRiskData(data || []);
      setTotalPages(pagination?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching risk flag records:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRiskFlagRecords(page);
  }, [page]);

  const handleAdd = () => {
    navigate("/renewals-add-risk-flag");
  };

  const getWarningFlagBadge = (flag) => {
    const flagColors = {
      High: "bg-danger",
      Medium: "bg-warning text-dark",
      Low: "bg-success",
      Critical: "bg-dark",
    };

    const colorClass = flagColors[flag] || "bg-secondary";

    return (
      <span className={`badge ${colorClass} px-3 py-1 rounded-pill`}>
        {flag}
      </span>
    );
  };

  return (
    <div className="container-fluid px-4 py-3">
      {/* Header Section */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
            <div>
              <h1 className="h2 mb-1 text-dark fw-bold">
                Risk Flag Management
              </h1>
              <p className="text-muted mb-0">
                Monitor and manage policy risk indicators
              </p>
            </div>
            <button
              onClick={handleAdd}
              className="btn btn-primary d-flex align-items-center gap-2 fw-semibold shadow-sm"
              style={{
                padding: "10px 20px",
                backgroundColor: "#122066",
                border: "none",
                borderRadius: "8px",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#0f1a57";
                e.target.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#122066";
                e.target.style.transform = "translateY(0)";
              }}
            >
              <svg
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
              </svg>
              Add Risk Flag
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="row">
        <div className="col-12">
          <div
            className="card border-0 shadow-sm"
            style={{ borderRadius: "12px" }}
          >
            <div className="card-body p-0">
              {loading ? (
                <div className="d-flex align-items-center justify-content-center py-5">
                  <div className="text-center">
                    <div
                      className="spinner-border text-primary mb-3"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="text-muted mb-0">
                      Loading risk flag records...
                    </p>
                  </div>
                </div>
              ) : (
                <>
                  {/* Stats Header */}
                  <div className="px-4 py-3 bg-light border-bottom">
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <h6 className="mb-0 text-dark">
                          Showing {riskData.length} of {totalPages * 15} records
                        </h6>
                      </div>
                      <div className="col-md-6 text-md-end">
                        <small className="text-muted">
                          Page {page} of {totalPages}
                        </small>
                      </div>
                    </div>
                  </div>

                  {/* Table */}
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th className="fw-semibold text-dark py-3 px-4 border-0">
                            Policy Number
                          </th>
                          <th className="fw-semibold text-dark py-3 px-4 border-0">
                            Carrier
                          </th>
                          <th className="fw-semibold text-dark py-3 px-4 border-0">
                            Warning Flag
                          </th>
                          <th className="fw-semibold text-dark py-3 px-4 border-0">
                            Plan of Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {riskData.length === 0 ? (
                          <tr>
                            <td colSpan={4} className="text-center py-5">
                              <div className="text-muted">
                                <svg
                                  width="48"
                                  height="48"
                                  fill="currentColor"
                                  viewBox="0 0 16 16"
                                  className="mb-3"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                  <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                                </svg>
                                <h6 className="mb-2">No Risk Flags Found</h6>
                                <p className="mb-0 small">
                                  Start by adding your first risk flag record
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          riskData.map((row, index) => (
                            <tr
                              key={row.id}
                              style={{
                                transition: "background-color 0.2s ease",
                                animation: `fadeIn 0.3s ease ${
                                  index * 0.1
                                }s both`,
                              }}
                            >
                              <td className="py-3 px-4 border-0">
                                <span className="fw-medium text-dark">
                                  {row.PolicyNumber}
                                </span>
                              </td>
                              <td className="py-3 px-4 border-0">
                                <span className="text-muted">
                                  {row.Carrier}
                                </span>
                              </td>
                              <td className="py-3 px-4 border-0">
                                {getWarningFlagBadge(row.WarningFlag)}
                              </td>
                              <td className="py-3 px-4 border-0">
                                <span
                                  className="text-dark"
                                  style={{
                                    maxWidth: "200px",
                                    display: "block",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {row.PlanOfAction}
                                </span>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Pagination */}
      {!loading && riskData.length > 0 && (
        <div className="row mt-4">
          <div className="col-12">
            <div className="d-flex justify-content-center align-items-center gap-2">
              <button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={page === 1}
                className="btn btn-outline-primary d-flex align-items-center gap-2"
                style={{
                  minWidth: "100px",
                  borderRadius: "8px",
                  opacity: page === 1 ? 0.5 : 1,
                  cursor: page === 1 ? "not-allowed" : "pointer",
                }}
              >
                <svg
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                  />
                </svg>
                Previous
              </button>

              <div className="mx-3 px-3 py-2 bg-light rounded-pill">
                <span className="fw-medium text-dark">
                  {page} of {totalPages}
                </span>
              </div>

              <button
                onClick={() =>
                  setPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={page === totalPages}
                className="btn btn-outline-primary d-flex align-items-center gap-2"
                style={{
                  minWidth: "100px",
                  borderRadius: "8px",
                  opacity: page === totalPages ? 0.5 : 1,
                  cursor: page === totalPages ? "not-allowed" : "pointer",
                }}
              >
                Next
                <svg
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .table tbody tr:hover {
          background-color: #f8f9fa !important;
        }

        .btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .card {
          overflow: hidden;
        }

        .badge {
          font-size: 0.75rem;
          font-weight: 600;
          letter-spacing: 0.5px;
        }
      `}</style>
    </div>
  );
};

export default ListRiskFlag;
